import React from 'react';
import { useParams } from 'react-router-dom';

import File from '@root/views/File/File';

const LandingPageGenerator = () => {
  const params = useParams();

  return (
    <File
      disableSelect
      id={params.id}
      templateType="landingPage"
      mapGenerateButtonProps={() => ({
        creditDecrementAmount: 8,
      })}
      showCustomLayoutExample
    />
  );
};

export default LandingPageGenerator;
